import { OrderStatus, OrderStatusEnum } from './model/orderCell';

export const statusTitle: Map<string, string> = new Map<string, string>();

statusTitle.set(OrderStatusEnum.RECEIVED, 'Order Received');
statusTitle.set(OrderStatusEnum.CANCELLED, 'Order Canceled');
statusTitle.set(OrderStatusEnum.SCHEDULED, 'Appointment Scheduled');
statusTitle.set(OrderStatusEnum.AWAITING_RESCHEDULE, 'Awaiting Reschedule');
statusTitle.set(OrderStatusEnum.APPOINTMENT_COMPLETE, 'Appointment Complete');
statusTitle.set(OrderStatusEnum.PROCESSING, 'Processing Assets');
statusTitle.set(OrderStatusEnum.DELIVERED, 'Order Delivered');
statusTitle.set(
  OrderStatusEnum.UNABLE_TO_COMPLETE,
  'Order Delivered - Unable to Complete'
);

export const getStatus = (key: string): OrderStatus | undefined => {
  const status: OrderStatus = {
    [OrderStatusEnum.RECEIVED]: false,
    [OrderStatusEnum.CANCELLED]: false,
    [OrderStatusEnum.SCHEDULED]: false,
    [OrderStatusEnum.AWAITING_RESCHEDULE]: false,
    [OrderStatusEnum.APPOINTMENT_COMPLETE]: false,
    [OrderStatusEnum.PROCESSING]: false,
    [OrderStatusEnum.UNABLE_TO_COMPLETE]: false,
    [OrderStatusEnum.DELIVERED]: false
  } as OrderStatus;

  const keys: string[] = Object.keys(status);
  for (let i = 0; i < keys.length; i++) {
    (status as Record<string, boolean | null | undefined>)[keys[i]] = true;
    if (key === 'order.canceled' && keys[i] === 'order.canceled') {
      (status as Record<string, boolean | null | undefined>)[keys[i]] = null;
    } else if (
      key === 'appointment.awaiting_reschedule' &&
      keys[i] === 'appointment.awaiting_reschedule'
    ) {
      (status as Record<string, boolean | null | undefined>)[keys[i]] =
        undefined;
    } else {
      if (
        key === 'order.unable_to_complete' &&
        keys[i] === 'order.unable_to_complete'
      ) {
        (status as Record<string, boolean | null | undefined>)[keys[i]] = null;
      }
    }

    if (keys[i] === key) {
      return status;
    }
  }
};

export const getStatusTitle = (status: string): string => {
  return statusTitle.get(status) || '';
};

interface OrderStatusOption {
  value: OrderStatusEnum;
  label: string;
}

export const getOrderStatusOptions = (): OrderStatusOption[] => {
  return [
    { value: OrderStatusEnum.RECEIVED, label: getStatusTitle(OrderStatusEnum.RECEIVED) },
    { value: OrderStatusEnum.CANCELLED, label: getStatusTitle(OrderStatusEnum.CANCELLED) },
    { value: OrderStatusEnum.SCHEDULED, label: getStatusTitle(OrderStatusEnum.SCHEDULED) },
    { value: OrderStatusEnum.AWAITING_RESCHEDULE, label: getStatusTitle(OrderStatusEnum.AWAITING_RESCHEDULE) },
    { value: OrderStatusEnum.APPOINTMENT_COMPLETE, label: getStatusTitle(OrderStatusEnum.APPOINTMENT_COMPLETE) },
    { value: OrderStatusEnum.PROCESSING, label: getStatusTitle(OrderStatusEnum.PROCESSING) },
    { value: OrderStatusEnum.DELIVERED, label: getStatusTitle(OrderStatusEnum.DELIVERED) },
    { value: OrderStatusEnum.UNABLE_TO_COMPLETE, label: getStatusTitle(OrderStatusEnum.UNABLE_TO_COMPLETE) }
  ];
};
